import ListTable from "./ListTable";

const ListSedangProses = (props) => {
  return (
    <ListTable
      {...props}
      title="SEDANG DI PROSES"
      rowFilter={(el) => !el.tanggal_pulang || !el.tanggal_pulang}
    />
  );
};

export default ListSedangProses;
